import Icon, { ICON_ALL_SPORTS } from '../../../icon';

type SportsbookSportIconProps = {
	className?: string;
	width?: string;
	height?: string;
	icon?: string;
};

const SportsbookSportIcon: React.FC<SportsbookSportIconProps> = ({ className, width, height, icon }) => (
	<Icon className={className} width={width} height={height} type={icon || ICON_ALL_SPORTS} />
);

export default SportsbookSportIcon;
